import { type InputHTMLAttributes, forwardRef } from 'react';

import { Input } from '@/components/ui/Input';

/**
 * Drop-in replacement for `<Input type="password" />`. Renders a masked
 * input — the browser's built-in dot rendering is enough; no reveal
 * toggle (Aaron's earlier report on the eyeball UI: "the show password
 * eyeball doesn't work" — left it out rather than ship a broken one).
 * Centralized so a future reveal pattern can land in one place.
 */
export const PasswordInput = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>
>(({ ...props }, ref) => {
  return <Input {...props} ref={ref} type="password" />;
});
PasswordInput.displayName = 'PasswordInput';
